import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: 48,
	},
	content: {
		alignItems: 'center',
		background: '#fff',
		border: '1px solid #D3DBDE',
		borderRadius: 8,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 600,
		padding: 48,
		textAlign: 'center',
		width: '100%',
	},
	successIcon: {
		alignItems: 'center',
		background: '#dcfce7',
		borderRadius: '50%',
		color: '#16a34a',
		display: 'flex',
		fontSize: 48,
		height: 80,
		justifyContent: 'center',
		marginBottom: 24,
		width: 80,
	},
	title: {
		color: '#333',
		fontSize: 28,
		fontWeight: 600,
		margin: '0 0 8px 0',
	},
	subtitle: {
		color: '#666',
		fontSize: 16,
		margin: '0 0 32px 0',
	},
	detailsCard: {
		background: '#f8f9fa',
		borderRadius: 8,
		padding: 24,
		textAlign: 'left',
		width: '100%',
	},
	detailRow: {
		alignItems: 'center',
		borderBottom: '1px solid #e9ecef',
		display: 'flex',
		fontSize: 14,
		justifyContent: 'space-between',
		padding: '12px 0',
		':last-child': {
			borderBottom: 'none',
		},
	},
	detailLabel: {
		color: '#666',
	},
	detailValue: {
		color: '#333',
		fontWeight: 500,
	},
	statusActive: {
		color: '#16a34a',
		fontWeight: 600,
		textTransform: 'capitalize',
	},
	statusPending: {
		color: '#ca8a04',
		fontWeight: 600,
		textTransform: 'capitalize',
	},
	link: {
		color: '#00AAE8',
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
	buttonRow: {
		display: 'flex',
		gap: 12,
		marginTop: 32,
	},
	amountHighlight: {
		color: '#16a34a',
		fontSize: 16,
		fontWeight: 600,
	},
});
